export default function createApplePayPaymentPayload({ appleToken, cart, installment, orderId }) {
  const { paymentData, paymentMethod, transactionIdentifier } = appleToken

  const {
    hash: cartHash,
    customer: { full_name, document_number },
    store_id,
  } = cart

  const payload = {
    name: full_name,
    document: document_number.replace(/[^a-zA-Z0-9]/g, ''),
    installments: installment,
    recaptcha_response: null, // Comparar com cartão
    recaptcha_attempts: 0, // Comparar com cartão
    store_id: store_id.toString(),
    order_id: orderId.toString(),
    cart: cartHash,
    paymentData: {
      data: paymentData.data,
      signature: paymentData.signature,
      header: {
        publicKeyHash: paymentData.header.publicKeyHash,
        ephemeralPublicKey: paymentData.header.ephemeralPublicKey,
        transactionId: paymentData.header.transactionId,
      },
      version: paymentData.version,
      paymentMethod: {
        displayName: paymentMethod.displayName,
        network: paymentMethod.network,
        type: paymentMethod.type,
      },
      transactionIdentifier,
    },
  }

  return payload
}
